<template>
    <div class="dialog_time5">
        <div class="dialog">
            <div class="close" @click="close"></div>
            <div class="txt">
                2分钟试看结束<br />
                请兑换/支付后继续观看
            </div>
            <div class="foot-buttons">
                <div class="abtn btn-exchange" @click="onExchange">去兑换</div>
                <div class="abtn btn-buy" @click="onBuy">去支付</div>
            </div>
        </div>
    </div>
</template>

<script> 

export default {
    components: {},
    data() {
        return {

        }
    },
    created() {

    },
    mounted() {

    },
    methods: {
        close() {
            this.$emit('close');
        },
        onExchange() {
            this.$emit('exchange');
        },
        onBuy() {
            this.$emit('buy');
        }
    }
};
</script>
<style scoped lang="scss">
$s1024: 1;
$s750: 1;
.dialog_time5 {
    width: 100%;
    height: 100%;
    position: fixed;
    left: 0;
    top: 0;
    z-index: 100;
    background: rgba(0, 0, 0, 0.8);
    .dialog {
        width: 3.24rem;
        height: 2.1rem;
        border: 1px solid #fff;
        border-radius: 0.2rem;
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        z-index: 1;
        @media screen and (max-width: 1024px) {
            width: (3.24rem * $s1024);
            height: (2.1rem * $s1024);
            border-radius: (0.2rem * $s1024);
        }
        @media screen and (max-width: 750px) {
            width: (3.24rem * $s750);
            height: (2.1rem * $s750);
            border-radius: (0.2rem * $s750);
        }
        .close {
            width: 0.21rem;
            height: 0.21rem;
            background: url(../assets/close.png) no-repeat center center;
            background-size: contain;
            position: absolute;
            right: 0.16rem;
            top: 0.16rem;
            cursor: pointer;
            @media screen and (max-width: 1024px) {
                width: (0.21rem * $s1024);
                height: (0.21rem * $s1024);
                right: (0.16rem * $s1024);
                top: (0.16rem * $s1024);
            }
            @media screen and (max-width: 750px) {
                width: (0.21rem * $s750);
                height: (0.21rem * $s750);
            }
        }
        .txt {
            width: 2.72rem;
            height: 0.9rem;
            position: absolute;
            left: 0.25rem;
            top: 0.3rem;
            display: flex;
            flex-direction: row;
            justify-content: center;
            align-items: center;
            align-content: center;
            font-size: 0.16rem;
            color: #fff;
            line-height: 2;
            text-align: center;
            border-bottom: 1px solid rgba(255, 255, 255, 0.6);
            @media screen and (max-width: 1024px) {
                width: (2.72rem * $s1024);
                height: (0.9rem * $s1024);
                left: (0.25rem * $s1024);
                top: (0.3rem * $s1024);
                font-size: (0.16rem * $s1024);
            }
            @media screen and (max-width: 750px) {
                width: (2.72rem * $s750);
                height: (0.9rem * $s750);
                left: (0.25rem * $s750);
                top: (0.3rem * $s750);
                font-size: (0.16rem * $s750);
            }
        }
        .foot-buttons {
            width: 2.72rem;
            position: absolute;
            left: 0.25rem;
            bottom: 0.3rem;
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            align-items: center;
            align-content: center;
            @media screen and (max-width: 1024px) {
                width: (2.72rem * $s1024);
                left: (0.25rem * $s1024);
                bottom: (0.3rem * $s1024);
            }
            @media screen and (max-width: 750px) {
                width: (2.72rem * $s750);
                left: (0.25rem * $s750);
                bottom: (0.3rem * $s750);
            }
            .abtn {
                width: 1.24rem;
                height: 0.36rem;
                font-size: 0.16rem;
                justify-content: center;
                align-content: center;
                align-items: center;
                display: flex;
                border-radius: 0.08rem;
                cursor: pointer;
                @media screen and (max-width: 1024px) {
                    width: (1.24rem * $s1024);
                    height: (0.36rem * $s1024);
                    font-size: (0.16rem * $s1024);
                    border-radius: (0.08rem * $s1024);
                }
                @media screen and (max-width: 750px) {
                    width: (1.24rem * $s750);
                    height: (0.36rem * $s750);
                    font-size: (0.16rem * $s750);
                    border-radius: (0.08rem * $s750);
                }

                &.btn-exchange {
                    border: 1px solid #d9dde3;
                    color: #6f6e71;
                    background-color: #d9dde3;
                }
                &.btn-buy {
                    border: 1px solid #eb2234;
                    background: #eb2234;
                    color: #fff;
                }
            }
        }
    }
}
</style>